<template>
    <div class="wxCode" :id="id" style="width: 100%;height: 100%"></div>
</template>
<script>
// 备忘录模式: 防止重复加载
const loadWeChatJs = (() => {
  let exists = false // 打点
  const src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js' // 微信sdk网址

  return () =>
    new Promise((resolve, reject) => {
      // 防止重复加载
      if (exists) return resolve(window.WxLogin)

      let script = document.createElement('script')
      script.src = src
      script.type = 'text/javascript'
      script.onerror = reject // TODO: 失败时候, 可以移除script标签
      script.onload = () => {
        exists = true
        resolve(window.WxLogin)
      }
      document.body.appendChild(script)
    })
})()
export default {
    name: 'wechart-qr',
    props: {
        id: '',
        redirectPath: ''
    },
    data () {
        return {
            AppID: 'wx10b1cb5f6e5f0053'
        }
    },
    created(){
        this.thirdLogin()
    },
    methods: {
        thirdLogin() {
            loadWeChatJs().then(WxLogin => {
                const origin = location.origin;
                // const origin = 'https://www.ztxhr.com'
                console.log('origin: ', origin)
                var obj = new WxLogin({
                    self_redirect: false,
                    id: this.id,
                    appid: this.AppID,
                    scope: 'snsapi_login',
                    //以下地址经过encodeURIComponent转义的结果
                    redirect_uri: origin + this.redirectPath,
                    state: encodeURIComponent(location.href),
                    style: '',
                    href: origin + '/static/wechat.css'
                })
            })
        }
    }
}
</script>
<style lang="less">
.wxCode iframe{
    width: 100%;
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// wechartQR.vue?6f80c76e